import src from "IMAGE";
export default { src, width: 965, height: 286, blurWidth: 0, blurHeight: 0};
